import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deletePost, getAllPosts } from '../api/axiosPosts';
import ProcessDelete from './../components/buttonActions/ProcessDelete';
import { Toast } from 'primereact/toast';
import { AllToasts } from './../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { Link, useNavigate } from 'react-router-dom';
import useWindowSize from '../hooks/useWindowSize';
import { useContext } from 'react';
import DataContext from '../context/DataContext';








const Posts = () => {
  const { posts, setPosts, post, setPost, fetcherror, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()
  const { width,height } = useWindowSize();

  const NewTitle =`All Posts ${width} X ${height}`

  const filteredPosts = posts.filter( (item) => item.title.toLowerCase().includes(globalFilter) || item.content.toLowerCase().includes(globalFilter))
  const filteredReversedPosts = filteredPosts.reverse();
  useEffect(() => {
    
    getAllPosts(setPosts, setFetcherror);
    

  }, []);
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };


  

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
        <div className="flex row m-1  justify-content-between">
                <div>
                  <Button
              label='+ Add'
              className='p-2 px-3'
              onClick={ ()=>navigate("/addpost")}
                  />
                </div>
          
                <div >
                    <InputText
                      className='p-2 px-3'
                      placeholder="Search"
                      icon="pi pi-search"
                      value={globalFilter}
                      onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                  </div>
               
              </div>
        
        <DataTable
          value={filteredReversedPosts}
          showGridlines
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No posts found"
        >
                    <Column header="S/N" body={(rowData) => posts.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Title"   body={(rowData) => rowData.title} sortable></Column>
                    <Column header="Content" body={(rowData) => rowData.content} sortable></Column>
                    <Column header="Actions" body={(rowData) => (
              
                      <ProcessDelete
              pkid={rowData.id}
              setFetcherror={setFetcherror}
              setPosts={setPosts}
              handleAllToasts={handleAllToasts}
              post={post}
              setPost={setPost}
                            />)
                              }>
                    </Column>
          </DataTable>
                
      </Card>

   
    </div>
  )
}

export default Posts